import { createContext, FC, useEffect, useMemo } from 'react';
import { Prompt } from '@ai-platform/utils';
import { createVisibilityTracker, VisibilityTracker } from '../VisibilityTracker';
import { useMarkAsViewed } from './useMarkAsViewed';
// import { useDebugOutline } from './useDebugOutline';

export type TrackerPromptData = { prompt: Prompt; needMarkAsViewed?: boolean };
export const PromptsViewedTrackerContext = createContext<VisibilityTracker<TrackerPromptData> | null>(null);

type Props = {
    children: React.ReactNode;
};

const PROMPT_CARD_VIEWED_THRESHOLD = 0.5; // считаем промпт в ленте видимым, если на экране половина карточки
const VIEWED_DELAY = 2000; // считаем промпт просмотренным, если он был видимым в течение 2 секунд
const tracker = createVisibilityTracker<TrackerPromptData>(PROMPT_CARD_VIEWED_THRESHOLD);

export const PromptsViewedTrackerProvider: FC<Props> = ({ children }) => {
    // const [outlineVisible, outlineHidden] = useDebugOutline();
    const [markVisiblePromptAsViewed] = useMarkAsViewed();

    // список обработчиков показанных промптов
    const shownHandlers = useMemo(
        () =>
            [
                // [outlineVisible, 0],
                [markVisiblePromptAsViewed, VIEWED_DELAY],
            ] as const,
        [
            // outlineVisible,
            markVisiblePromptAsViewed,
        ],
    );

    // список обработчиков скрытых промптов
    const hiddenHandlers = useMemo(
        () =>
            [
                // [outlineHidden, 0],
            ] as const,
        [
            // outlineHidden,
        ],
    );

    useEffect(() => {
        // в случае SSR обсервер создать не удастся и регистрировать обработчики не нужно
        if (!tracker) {
            return;
        }

        // регистрируем обработчики показанных промптов
        for (const [handler, delay] of shownHandlers) {
            tracker.addHandler('shown', handler, delay);
        }

        // регистрируем обработчики скрытых промптов
        // for (const [handler, delay] of hiddenHandlers) {
        //     observer.addHandler('hidden', handler, delay);
        // }

        return () => {
            // удаляем обработчики
            for (const [handler] of shownHandlers) {
                tracker.removeHandler(handler);
            }
            // for (const [handler] of hiddenHandlers) {
            //     observer.removeHandler(handler);
            // }
        };
    }, [hiddenHandlers, shownHandlers]);

    return <PromptsViewedTrackerContext.Provider value={tracker}>{children}</PromptsViewedTrackerContext.Provider>;
};
